// use the following structure
//
// <div class="with-tabs">
//   <ul class="tabs">
//     <li class="tab {% if forloop.index == 1 %}active{% endif %}" data-href="{{ block.id }}"></li>
//   </ul>
//   <div id="{{ block.id }}" class="tab-content {% if forloop.index == 1 %}active{% endif %}"></div>
// </div>
// 
// @see example in sections/home-page-collections

(function() {
  let tabsWrapperId = null;
  
  const refreshTabs = (event) => {
    tabsWrapperId = event?.value?.wrapperId || null;
  
    initTabs();
  
    const fireDone = new Event('reInitTabsDone');
    fireDone.value = {
      wrapperId: tabsWrapperId
    };
    document.dispatchEvent(fireDone);

    tabsWrapperId = null;
  };
  
  // init tabs on event if needed
  document.addEventListener("reInitTabs", refreshTabs, false);
  
  
  const processTabClick = (event) => {
    event.preventDefault();

    let target = event.target;

    if(!target.classList.contains('tab')) {
      target = event.target.closest('.tab');
    }

    const tabs = getTabs();
    const tabsContents = getContents();
    const activeTabId = target.dataset.href;
    const activeTab = document.querySelector(`.with-tabs .tab-content#${activeTabId}`);
    tabsWrapperId = activeTab.closest(`.with-tabs`).getAttribute('id');
  
    tabsContents.forEach(el => el.classList.remove('active'));
    tabs.forEach(el => el.classList.remove('active'));
    
    activeTab.classList.add('active');
    target.classList.add('active');

    const fireDone = new Event('contentActivated');
    fireDone.value = {
      wrapperId: tabsWrapperId,
      activeContent: activeTab
    };
    document.dispatchEvent(fireDone);

    tabsWrapperId = null;
  };
  
  const initTabs = () => {
    const tabs = getTabs();
    
    tabs.forEach(tab => {
      tab.removeEventListener('click', processTabClick);
      tab.addEventListener('click', processTabClick);

      tab.childNodes.forEach(child => {
        child.removeEventListener('click', processTabClick);
        child.addEventListener('click', processTabClick);
      })
    });
  };
  
  const getTabs = () => {
    if(tabsWrapperId !== null) {
      return document.querySelectorAll(`#${tabsWrapperId} .tab`);
    }
  
    return document.querySelectorAll(".with-tabs ul.tabs .tab");
  };
  
  const getContents = () => {
    if(tabsWrapperId !== null) {
      return document.querySelectorAll(`#${tabsWrapperId} .tab-content`);
    }
  
    return document.querySelectorAll(".with-tabs .tab-content");
  };
  
  initTabs();
})();